function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M1001.6 34.4c0-19.6 15.3-33.9 34.4-33.9 19.1 0 34.4 14.3 34.4 33.9 0 18.6-15.3 32.9-34.4 32.9-19.1 0-34.4-14.3-34.4-32.9zM1006.6 94.7h59v257.7h-59zM847.6 352.4c-68.4 0-119.9-51.6-119.9-120V94.7h59v137.8c0 37.6 23.3 63.9 61 63.9 37.9 0 61.4-26.3 61.4-63.9V94.7h59v137.8c-.1 69.4-50.7 119.9-120.5 119.9zM576.3 94.9h-52.1V5.5h-59v346.9h111.1c74.9 0 129.2-54.1 129.2-128.8.1-74.6-54.3-128.7-129.2-128.7zm0 201.6h-52.1V150.8h52.1c43.2 0 65.6 32.7 65.6 72.8-.1 40.2-22.4 72.9-65.6 72.9zM1334.4 122V67.3h-67.1V5.5h-59v245.9c0 62.6 35.9 101 93.8 101h11.3v-54.9c-28.7 0-46.1-13.8-46.1-46.1V122h67.1zM1110.7 5.5h59v346.9h-59z",
  fill: "#232846"
}), React.createElement("path", {
  d: "M165.2 23.7L59.3 84.9V5.5H.3v346.9L165.2 257l164.9 95.3V119.1L165.2 23.7zm105.9 226.4l-105.9-61.2-105.9 61.2v-94.3l105.9-61.2 105.9 61.2v94.3z",
  fill: "#D25459"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 1335,
    height: 353
  }, props), _ref);
};

export default __webpack_public_path__ + 'static/media/img-built-logo.e33d533f.svg';
export { SvgComponent as ReactComponent };


// WEBPACK FOOTER //
// ./src/images/img-built-logo.svg